import React from 'react';

const TermsOfService = () => {
  return (
    <div className="space-y-8 text-swiss-black leading-relaxed">
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">1. Agreement to Terms</h2>
        <p className="font-medium">
          These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and Millrock Industries Private Limited, operating as SVNATE ("we," "us" or "our"), concerning your access to and use of our website and services. You agree that by accessing the site and engaging our services, you have read, understood, and agree to be bound by all of these Terms and Conditions.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">2. Services and Deliverables</h2>
        <p className="font-medium">
          We agree to provide digital services including but not limited to web development, mobile application development, UI/UX design, and custom software architecture. Specific deliverables, timelines, and features will be explicitly stated in the formal Project Proposal and Statement of Work (SOW) agreed upon by both parties before project commencement.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">3. Payments and Deposits</h2>
        <p className="font-medium">
          All project estimates and invoices are issued in Indian Rupees (₹) unless otherwise specified. A non-refundable deposit is required to commence work, as outlined in the Statement of Work. Final deliverables (source code, production deployment, assets) will not be transferred to the client until the final invoice is paid in full.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">4. Intellectual Property Rights</h2>
        <p className="font-medium">
          Upon full payment of all outstanding invoices, the client is granted full ownership and intellectual property rights to the custom source code and assets explicitly created for their project. Millrock Industries Private Limited retains the right to reuse underlying open-source libraries, generic utility boilerplate code, and foundational architectures in future projects.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">5. Limitation of Liability</h2>
        <p className="font-medium">
          In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, loss of data, or other damages arising from your use of our services or software deliverables.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">6. Governing Law</h2>
        <p className="font-medium">
          These Terms and Conditions and your use of our services are governed by and construed in accordance with the laws of the State of Maharashtra, India, without regard to its conflict of law principles.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
